<mat-form-field class="col__"
                #triggerContainer>
  <mat-label>{{ labelText || 'Search Entities' }}</mat-label>
  <input matInput
         type="search"
         autocomplete="off"
         cdkOverlayOrigin
         (keydown.arrowdown)="setFirstItemActive()"
         #trigger="cdkOverlayOrigin"
         [formControl]="searchInput">
  <i *ngIf="loadingResults"
     matSuffix
     style="margin-right: 10px"
     class="fal fa-spinner-third fa-spin loader__icon">
  </i>
</mat-form-field>

<ng-template cdkConnectedOverlay
             (overlayOutsideClick)="closeOverlay()"
             [cdkConnectedOverlayOrigin]="trigger"
             [cdkConnectedOverlayWidth]="triggerWidth$ | async"
             [cdkConnectedOverlayMinWidth]="'300px'"
             [cdkConnectedOverlayOpen]="isOpen">
  <div class="autocomplete-overlay w-100 mt-0050 bg-color--white"
       style="position:relative;left: -.75rem;"
       [ngClass]="triggerClass">
    <div (keydown)="onKeydown($event)"
         #resultsEl>

      <app-list-item class="results__entity d-flex flexJustify-between flexAlign-center m-0"
                     *ngFor="let entity of searchResults"
                     [item]="entity"
                     (click)="onEntitySelected(entity)">

        <app-entity-avatar [assessmentLevel]="entity.currentAssessmentLevel"
                           [spotlightIcon]="entity.spotlightIcon"
                           [entityTypeId]="entity.entityTypeId"
                           [isUser]="entity?.linkedUserId"
                           size="sm">
        </app-entity-avatar>
        <div class="results__main">
          <app-entity-name [entity]="entity"></app-entity-name>
          <span class="results__location">{{entity?.bestAddress | cityState}}</span>
        </div>
      </app-list-item>


      <app-list-item class="results__entity results__entity--empty d-flex flexJustify-between flexAlign-center"
                     [item]="canCreateNew ? 'create_new' : null"
                     (click)="canCreateNew ? onCreateNewEntity() : null"
                     *ngIf="!noResults">
        <div class="results__main">
          <span class="results__name"
                *ngIf="canCreateNew">
            <i class="fal fa-plus-circle"></i>
            <button class="link link--blue link--noline"
                    type="button">
              Create New Entity?
            </button>
          </span>
        </div>
      </app-list-item>

      <app-list-item class="results__entity results__entity--empty d-flex flexJustify-between flexAlign-center"
                     [item]="canCreateNew ? 'create_new' : null"
                     (click)="canCreateNew ? onCreateNewEntity() : null"
                     *ngIf="noResults">
        <div class="results__main">

          <span class="results__name">No results</span>
          <span class="results__name"
                *ngIf="canCreateNew">
            <i class="fal fa-plus-circle"></i>
            <button class="link link--blue link--noline"
                    type="button">
              Create New Entity?
            </button>
          </span>
        </div>
      </app-list-item>
    </div>

  </div>

</ng-template>
